import React from 'react';
import Config from 'config';

import MiddleEarthLogo from '../../../img/marionette-logo.png';
import GrabLogo from '../../../img/logo.png';

import './ConcedoLoginPage.scss';

const SignInComponent = () => (
  <div className="mainBody">
    <div className="contentBody">
      <div className="logoContainer">
        <img src={MiddleEarthLogo} alt="Marionette Logo" />
      </div>
      <span className="welcomeText">Welcome to Marionette</span>
      <a href={Config.CONCEDO_URL} className="loginButton">
        Login with Concedo
      </a>
    </div>
    <div className="footer">
      <span>Made with love by </span>
      <img src={GrabLogo} alt="Grab Logo" />
    </div>
  </div>
);

export default SignInComponent;



/** WEBPACK FOOTER **
 ** ./src/js/views/auth/ConcedoLoginPage.jsx
 **/